import { createAction } from "@reduxjs/toolkit";
import {
  ANALYTICS_ADD_PENDING_EVENT,
  ANALYTICS_CLEAR_ALL_REFINEMENTS,
  ANALYTICS_CLEAR_REFINEMENT,
  ANALYTICS_REFINEMENTS_SELECT,
  ANALYTICS_REFINEMENTS_SORT,
  ANALYTICS_REFINEMENTS_TOGGLED,
  ANALYTICS_REMOVE_PENDING_EVENT,
  ANALYTICS_SELECT_ALL,
  ANALYTICS_SMALL_VIEW_SUBMIT,
} from "../constants";
import {
  analyticsClearAllRefinements,
  analyticsClearRefinement,
  analyticsRefinementsSelect,
  analyticsRefinementsSort,
  analyticsRefinementsToggled,
  analyticsSelectAll,
  analyticsSmallViewSubmit,
} from "./analyticsRefinements";

// A Map prevents inherited object keys from being treated as registered events.
const REFINEMENT_EVENTS = new Map([
  [ANALYTICS_CLEAR_ALL_REFINEMENTS, analyticsClearAllRefinements],
  [ANALYTICS_CLEAR_REFINEMENT, analyticsClearRefinement],
  [ANALYTICS_REFINEMENTS_SELECT, analyticsRefinementsSelect],
  [ANALYTICS_REFINEMENTS_SORT, analyticsRefinementsSort],
  [ANALYTICS_REFINEMENTS_TOGGLED, analyticsRefinementsToggled],
  [ANALYTICS_SELECT_ALL, analyticsSelectAll],
  [ANALYTICS_SMALL_VIEW_SUBMIT, analyticsSmallViewSubmit],
]);

export const isRefinementEvent = (type) => REFINEMENT_EVENTS.has(type);

export const refinementEvent = (type, payload) => {
  const createEvent = REFINEMENT_EVENTS.get(type);

  if (!createEvent) {
    throw new Error(`Unknown refinement event: ${String(type)}`);
  }

  return createEvent(payload);
};

export const bufferRefinementEvent = createAction(
  ANALYTICS_ADD_PENDING_EVENT,
  (type, payload) => ({
    payload: {
      refinementPendingActionType: type,
      refinementPendingPayload: payload,
    },
  }),
);

export const clearBufferedRefinementEvent = createAction(
  ANALYTICS_REMOVE_PENDING_EVENT,
);
